import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { SHOWCASE_CONFIG } from '../../constants';
import NumberShowcaseItem from '../NumberShowcaseItem';
import { Container, Items, SubTitle } from './styles';

const NumbersShowcase: FC = () => (
  <Container>
    <SubTitle>
      <FormattedMessage id={SHOWCASE_CONFIG.titleKey} />
    </SubTitle>
    <Items>
      {SHOWCASE_CONFIG.items.map(({ imgSrc, titleKey, subtitleKey }) => (
        <NumberShowcaseItem key={titleKey} imgSrc={imgSrc} titleKey={titleKey} subtitleKey={subtitleKey} />
      ))}
    </Items>
  </Container>
);

export default NumbersShowcase;
